import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RankingNode } from './cpq-ranking.model';

@Component({
    selector: 'cpq-ranking-dialog',
    templateUrl: './cpq-ranking-dialog.component.html',
    styleUrls: ['./cpq-ranking-dialog.component.scss'],
    standalone: false
})
export class CpqRankingDialogComponent implements OnInit {
  title = 'Admin.add_edit_attribute.Rank';

  constructor(public dialogRef: MatDialogRef<CpqRankingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data.title) {
      this.title = this.data.title;
    }
  }

  updateRanks(rankingNodes: Array<RankingNode>) {
    this.data.nodes = rankingNodes;
  }

  resetRanks() {
    let counter = 1;
    this.data.nodes.forEach((node: RankingNode) => {
      node.position = counter++;
    });
  }

  save() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
